import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

export const Contact = () => {
  const handleTypeformClick = () => {
    window.open('https://form.typeform.com/to/Ez5QlP6D', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-cyan-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Contribuisci con la tua opinione
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            La tua opinione è importante per noi. Partecipa alla costruzione della nuova idea di Spresiano.
          </p>
          <Button
            onClick={handleTypeformClick}
            size="lg"
            className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-6 text-lg group"
          >
            Contribuisci con la tua opinione
            <ExternalLink className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};
